import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import { Spinner } from "@/components/bits";
import Landing from "@/pages/Landing";
import { Login, Register, ForgotPassword, ResetPassword, VerifyEmail } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Groups from "@/pages/Groups";
import CreateGroup from "@/pages/CreateGroup";
import GroupDetail from "@/pages/GroupDetail";
import Contributions from "@/pages/Contributions";
import Goals from "@/pages/Goals";
import Activity from "@/pages/Activity";
import Reports from "@/pages/Reports";
import Members from "@/pages/Members";
import Notifications from "@/pages/Notifications";
import Settings from "@/pages/Settings";
import Funds from "@/pages/Funds";
import Pay from "@/pages/Pay";
import History from "@/pages/History";
import Todo from "@/pages/Todo";
import CreateActivity from "@/pages/CreateActivity";
import ActivityDetail from "@/pages/ActivityDetail";
import Platform from "@/pages/Platform";
import Support from "@/pages/Support";
import PayReturn from "@/pages/PayReturn";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center"><Spinner /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

const Public = ({ children }) => {
  const { user } = useAuth();
  if (user) return <Navigate to="/app" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Public><Login /></Public>} />
            <Route path="/signup" element={<Public><Register /></Public>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/join" element={<Navigate to="/app/groups?join=1" replace />} />
            <Route path="/platform/*" element={<Protected><Platform /></Protected>} />
            <Route path="/app" element={<Protected><AppShell /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="groups" element={<Groups />} />
              <Route path="groups/new" element={<CreateGroup />} />
              <Route path="groups/:id" element={<GroupDetail />} />
              <Route path="contributions" element={<Contributions />} />
              <Route path="goals" element={<Goals />} />
              <Route path="activity" element={<Activity />} />
              <Route path="reports" element={<Reports />} />
              <Route path="members" element={<Members />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="settings" element={<Settings />} />
              <Route path="funds" element={<Funds />} />
              <Route path="pay" element={<Pay />} />
              <Route path="pay/return" element={<PayReturn />} />
              <Route path="history" element={<History />} />
              <Route path="todo" element={<Todo />} />
              <Route path="groups/:id/activities/new" element={<CreateActivity />} />
              <Route path="activities/:id" element={<ActivityDetail />} />
              <Route path="support" element={<Support />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
